import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import { ReactComponent as SepaIcon } from '../assets/icons/sepa.svg';
import { ReactComponent as SepaDebitIcon } from '../assets/icons/sepadebit.svg';
import { ReactComponent as GiroPayIcon } from '../assets/icons/giropay.svg';
import { ReactComponent as PayPalIcon } from '../assets/icons/paypal.svg';
import { ReactComponent as CreditCardIcon } from '../assets/icons/creditcard.svg';
import { ReactComponent as SofortIcon } from '../assets/icons/sofort.svg';
import { Button, Select, Paper, Typography, InputLabel, FormControl, List, ListItem, TextField, MenuItem, FormControlLabel, Checkbox } from "@material-ui/core";
import IconLabel from './IconLabel';
import PriceCard from './PriceCard';
import PaymentCard from './PaymentCard';
import Service from "../services/service";
import { config, timeConverter, formatMoney } from '../helpers/constants.js';


export default function CheckoutSelectPaymentPanel(props) {

    function paymentOptions(strings) {
        let options = [];
        options.push({
            id: "creditcard",
            text: strings.payment.creditcard,
            icon: <CreditCardIcon />,
            currencies: ["EUR", "USD"],
            categories: [1, 3, 5, 8]
        });
        options.push({
            id: "paypal",
            text: strings.payment.paypal,
            icon: <PayPalIcon />,
            currencies: ["EUR", "USD"],
            categories: [1, 3, 5, 8]
        });
      /*  options.push({
            id: "sofort",
            text: strings.payment.sofort,
            icon: <SofortIcon />,
            currencies: ["EUR"],
            categories: [1, 5, 8]
        });*/
       /* options.push({
            id: "giropay",
            text: strings.payment.giropay,
            icon: <GiroPayIcon />,
            currencies: ["EUR"],
            categories: [1, 5, 8]
        });*/
        options.push({
            id: "banktransfer",
            text: strings.payment.banktransfer,
            icon: <SepaIcon />,
            currencies: ["EUR"],
            categories: [1, 5, 8]
        });
        /*        options.push({
                    id: "directdebit",
                    text: strings.payment.directdebit,
                    icon: <SepaDebitIcon />,
                    currencies: ["EUR"],
                    categories: [3, 5]
                });*/
        /*
        options.push({
            id: "invoice",
            text: "Kauf auf Rechnung",
            icon: <SepaDebitIcon />,
            currencies: ["EUR"],
            categories: [5]
        });
        options.push({
            id: "quote",
            text: "Angebot einholen",
            icon: <SepaDebitIcon />,
            currencies: ["EUR"],
            categories: [1, 5]
        });
        */


        return options;
    };

    const useStyles = makeStyles((theme) => ({
        root: {
            height: "100%",
            display: "grid",
            gridTemplateColumns: "16px 1fr 1fr 16px",
            gridTemplateRows: (props.wizard) ? "0px 1fr 110px" : "80px 1fr 110px",
            gridTemplateAreas: `
            "infoBar infoBar infoBar infoBar"
            "leftMargin productPanel paymentPanel rightMargin"
            "leftMargin bottomBar bottomBar rightMargin"
            `,
            gap: "8px 20px",
        },
        paper: {
            padding: 32,
            textAlign: "left"
        },
        leftMargin: { gridArea: "leftMargin" },
        rightMargin: { gridArea: "rightMargin" },
        infoBar: {
            gridArea: "infoBar",
            alignSelf: "center",
            justifySelf: "center",
            display: (props.wizard) ? "none" : "block"
        },
        productPanel: {
            marginTop: "16px",
            gridArea: "productPanel",
            alignSelf: "top",
            justifySelf: "center",
            textAlign: "center"
        },
        paymentPanel: {
            gridArea: "paymentPanel",
            alignSelf: "top",
            justifySelf: "left"
        },
        bottomBar: {
            gridArea: "bottomBar",
            justifySelf: "stretch",
            textAlign: "center",
            alignSelf: "start",
            paddingTop: 0
        },
        fullWidth: {
            width: "100%",
            marginBottom: theme.spacing(1)
        },
    }));

    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const classes = useStyles();
    const [invoiceData, setInvoiceData] = useState({});
    const catalogProduct = state.checkout.productId ? state.checkout.products.filter(p => p.id == state.checkout.productId)[0] : null;
    // Pay-invoice: the invoice's product may not be part of the purchasable catalog, so fall back to GetInvoiceData
    const selectedProduct = catalogProduct
        || ((props.type == "payInvoice" && invoiceData && invoiceData.invoiceId)
            ? { id: invoiceData.productId, categoryId: invoiceData.productCategoryId, nameShort: invoiceData.productName }
            : null);

    useEffect(() => {
        // Display in pay invoice context, select the purchased invoice product as selectedProduct
        if (state.checkout.invoiceId) {
            Service.getInvoiceData(state.checkout.invoiceId).then(res => {
                if (res.success) {
                    setInvoiceData(res.data);
                    dispatch(actions.setCheckoutDetails({ productId: res.data.productId, term: res.data.contractPeriod }));
                }
            });
        } else {
            setInvoiceData({});
        }

    }, [state.checkout.invoiceId]);

    const handleCheckoutChange = (newValue, key) => {
        dispatch(actions.setCheckoutDetails({ [key]: newValue }));
    }

    const handlePaymentChange = (newPaymentId) => {
        dispatch(actions.setCheckoutDetails({ paymentId: newPaymentId }));
    }

    const onDownloadInvoiceClicked = () => {
        const url = config.backendUrl + "export/?rid=" + state.checkout.invoiceId;
        window.open(url, "_blank");
    }

    if (!selectedProduct) {
        return (
            <div className={classes.root}></div>
        );
    }

    return (
        <div className={classes.root}>
            <div className={classes.leftMargin} />
            <div className={classes.rightMargin} />
            <div className={classes.infoBar}>
                {props.type == "payInvoice" ?
                    <IconLabel spacing={32} label={s.paymentDialog.paymentCanceled} />
                    :
                    <IconLabel spacing={32} label={s.paymentDialog.selectMethod} />
                }
            </div>
            <div className={classes.productPanel}>
                {/* in case the dialog is called to pay an already existing invoice, show the invoice details instead of the selected product */}
                {props.type == "payInvoice" ?
                    (invoiceData && invoiceData.invoiceId &&
                        <Paper className={classes.paper} square elevation={5}>
                            <Typography variant="h6">{s.paymentDialog.invoiceNo.format(invoiceData.invoiceId)}</Typography>
                            <Typography variant="caption" color="secondary">{s.paymentDialog.orderDate}</Typography>
                            <Typography>{s.paymentDialog.orderNoOf.format(invoiceData.orderId, timeConverter(invoiceData.orderDate, null, s.common.dateFormat))}</Typography>
                            <Typography variant="caption" color="secondary">{s.paymentDialog.purchasedProduct}</Typography>
                            <Typography>{invoiceData.productName}</Typography>
                            {invoiceData.licenseCode &&
                                <>
                                    <Typography variant="caption" color="secondary">{s.paymentDialog.licensePhase.format(invoiceData.licenseCode, invoiceData.licensePhase)}</Typography>
                                    <Typography>{"{0} - {1}".format(timeConverter(invoiceData.validFrom, null, s.common.dateFormat), timeConverter(invoiceData.validTo, null, s.common.dateFormat))}</Typography>
                                </>
                            }
                            <Typography variant="caption" color="secondary">{s.paymentDialog.invoiceAmount} {invoiceData.vatType ? s.paymentDialog.inclVAT : s.paymentDialog.exclVAT}</Typography>
                            <Typography variant="h6">{"{0} {1}".format(formatMoney(invoiceData.amount), invoiceData.currency)}</Typography>

                            <div style={{ marginTop: 32, width: "100%", textAlign: "center" }}>
                                <Button variant="outlined" onClick={onDownloadInvoiceClicked}>{s.paymentDialog.downloadInvoice}</Button>
                            </div>
                        </Paper>
                    )
                    :
                    <>
                        {selectedProduct && selectedProduct.categoryId == 1 &&
                            <PriceCard title={selectedProduct.nameShort}
                                text1={s.paymentDialog.priceCardCredits.format(selectedProduct.credits)}
                                text2={s.paymentDialog.priceCardPages.format(selectedProduct.credits)}
                                text3={selectedProduct.users}
                                price={selectedProduct.cost[state.checkout.currency]}
                                currency={state.checkout.currency}
                                selected={true}
                                taxIncluded={state.checkout.taxIncluded} 
                                vatRate={state.checkout.vatRate} />
                        }
                        {selectedProduct && selectedProduct.categoryId > 1 &&
                            <PriceCard title={selectedProduct.nameShort}
                                text1={selectedProduct.credits + " ScanCredits " + (state.checkout.term == "monthly" ? s.paymentDialog.perMonth : s.paymentDialog.perYear)}
                                text2={s.paymentDialog.unlimitedUsers}
                                text3={selectedProduct.users}
                                price={selectedProduct.cost[state.checkout.currency]}
                                currency={state.checkout.currency}
                                selected={true}
                                taxIncluded={state.checkout.taxIncluded} 
                                vatRate={state.checkout.vatRate}/>
                        }

                        {!props.wizard &&
                            <FormControl variant="outlined" style={{ marginTop: 20 }}>
                                <InputLabel>{s.paymentDialog.currency}</InputLabel>
                                <Select
                                    onChange={(e) => handleCheckoutChange(e.target.value, 'currency')}
                                    label={s.paymentDialog.currency}
                                    value={state.checkout.currency}
                                >
                                    <MenuItem value={"USD"}>USD</MenuItem>
                                    <MenuItem value={"EUR"}>EUR</MenuItem>
                                </Select>
                            </FormControl>
                        }
                    </>
                }
            </div>
            <div className={classes.paymentPanel}>
                {state.user.mandate &&
                    <>
                        <Typography variant="body2" color="secondary">{s.paymentDialog.savedPaymentMethods}</Typography>
                        {state.user.mandate.method == "paypal" ?
                            <PaymentCard
                                icon={<PayPalIcon />}
                                text={state.user.mandate.paypal}
                                subtext={s.payment.date.format(timeConverter(state.user.mandate.date, null, s.common.dateFormat))}
                                paymentId={state.user.mandate.id}
                                selected={state.checkout.paymentId == state.user.mandate.id}
                                handleChange={handlePaymentChange}
                            />
                            :
                            <PaymentCard
                                icon={<CreditCardIcon />}
                                text={s.paymentDialog.creditCardText.format(state.user.mandate.name, state.user.mandate.number)}
                                subtext={s.paymentDialog.creditCardSubText.format(timeConverter(state.user.mandate.expiryDate, null, s.common.dateFormat))}
                                paymentId={state.user.mandate.id}
                                selected={state.checkout.paymentId == state.user.mandate.id}
                                handleChange={handlePaymentChange}
                            />
                        }
                        <Typography style={{ marginTop: 8 }} variant="body2" color="secondary">{s.paymentDialog.furtherPaymentMethods}</Typography>
                    </>}
                {paymentOptions(state.strings).filter(p => p.currencies.includes(state.checkout.currency) && p.categories.includes(selectedProduct.categoryId)).map((p) => (
                    <PaymentCard icon={p.icon} text={p.text} paymentId={p.id} selected={state.checkout.paymentId == p.id}
                        handleChange={handlePaymentChange}
                    />
                ))}
                {(state.checkout.paymentId == "banktransfer") && 
                    <Typography style={{ marginTop: 16 }} variant="body2" color="error">{s.paymentDialog.warningBankTransfer}</Typography>
                }
                {((state.checkout.paymentId == "creditcard") || (state.checkout.paymentId == "paypal"))  && 
                    <Typography style={{ marginTop: 16 }} variant="body2" color="secondary">{s.paymentDialog.hintImmediatePayment}</Typography>
                }
                {selectedProduct && selectedProduct.categoryId > 1 && (state.checkout.paymentId == "creditcard" || state.checkout.paymentId == "paypal") &&
                    <Typography style={{ marginTop: 8 }} variant="body2" color="secondary">{s.paymentDialog.mandateSaved}</Typography>
                }
            </div>
            <div className={classes.bottomBar}>
                {selectedProduct && selectedProduct.categoryId == 1 && !state.checkout.invoiceId &&
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={state.checkout.withdrawalConsentChecked}
                                onChange={(e) => dispatch(actions.setCheckoutDetails({ withdrawalConsentChecked: e.target.checked }))}
                                color="primary"
                            />
                        }
                        label={
                            <Typography variant="body2" color="secondary" style={{ textAlign: "left" }}>
                                {s.paymentDialog.withdrawalConsent}
                            </Typography>
                        }
                        style={{ marginBottom: 4, alignItems: "flex-start", width: "100%" }}
                    />
                }
                {selectedProduct && selectedProduct.categoryId > 1 ?
                    <Typography variant="body2" style={{ paddingTop: 8 }} color="secondary">{s.payment.subscriptionCharge}</Typography>
                    :
                    <Typography variant="body2" style={{ paddingTop: 8 }} color="secondary">{s.paymentDialog.oneOffPayment}</Typography>}
            </div>
        </div>
    );
}